import { isBeautyApp } from '@ori/beauty-app-info';
import useTestId from '@ori/testid-generator';
import { TOP_BANNER_BREADCRUMBS } from "./constants";
import { BreadcrumbsRoot } from "./styles";
import { Breadcrumbs } from "../Breadcrumbs";

/**
 * Component for displaying breadcrumbs in TopBanner. For beauty app and empty `breadcrumbs` returns `null`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var TopBannerBreadcrumbs = function TopBannerBreadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (isBeautyApp() || !breadcrumbs || breadcrumbs.length < 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(BreadcrumbsRoot, {
    "data-testid": getTestId(TOP_BANNER_BREADCRUMBS),
    children: /*#__PURE__*/_jsx(Breadcrumbs, {
      breadcrumbs: breadcrumbs
    })
  });
};
TopBannerBreadcrumbs.displayName = 'Breadcrumbs';
//# sourceMappingURL=TopBannerBreadcrumbs.js.map